import { useTranslation } from "react-i18next";

export const Statement = () => {
  const { t } = useTranslation();
  return (
    <section id="statement" className="bg-cream text-cream-foreground py-32 md:py-48">
      <div className="container-x max-w-5xl">
        <p className="text-[10px] uppercase tracking-[0.3em] text-cream-foreground/60 mb-10">
          {t("statement.eyebrow")}
        </p>
        <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.1] tracking-tight">
          {t("statement.body")}
        </h2>
        <p className="mt-12 text-sm uppercase tracking-[0.2em] text-cream-foreground/60">
          {t("statement.author")}
        </p>
      </div>
    </section>
  );
};
